export default __webpack_public_path__ + "static/media/question.b779db1d.svg";